import axios from 'axios';
import env from 'src/env';

const loginLuminaOnline = async (practitionerId: number) => {
    const authToken = localStorage.getItem('id_token');
    const ssoVersion = localStorage.getItem('ssoVersion');
    let url = '/ssoservices/loginauth0mapped';
    let userType = 'affiliate';
    if (ssoVersion === '2') {
        url = '/ssoservicesv2/loginKeycloakUser';
        userType = 'practitioner';
    }
    await axios.request({
        baseURL: env.luminaOnlineUrl,
        url,
        method: 'POST',
        withCredentials: true,
        headers: {
            'content-type': 'application/json',
            Authorization: authToken,
        },
        data: {
            lumina_user_type: userType,
            lumina_user_id: practitionerId,
        },
    });
};

// eslint-disable-next-line import/prefer-default-export
export { loginLuminaOnline };